import type { AnticipationData } from '../AnticipationPeriodModal';

export const ANTICIPATION_FRAUD_GROUP = 2;

export type Props = {
  anticipationData: AnticipationData;
  isOpen: boolean;
  setClose: () => void;
  updateTransferAvailable: () => void;
  handleToggleTransferModal: () => void;
  handleUpdateAvailableAmount: () => void;
  handleOpenSuggestionAnticipation: () => void;
  handleOpenFidcModal: () => void;
  loadSuggestionAnticipation: () => void;
  hasSuggestionAnticipation: boolean;
  anticipationGroupInfo: AnticipationGroupInfo;
};

export type AnticipationOptions = {
  fee: number;
  invoices: number;
  value: number;
};

export type AnticipationByValue = {
  invoices: number;
  low_value?: AnticipationOptions;
  percent: number;
  request_value?: AnticipationOptions;
  total: number;
  total_fee: number;
  up_value?: AnticipationOptions;
};

export type AnticipationGroupInfo = {
  id: number;
  name: string;
  percent: number;
};
